/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon16Solid = forwardRef('KonturBonusSignIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1.5a1 1 0 0 0-2 0V3H5.5A1.5 1.5 0 0 0 4 4.5v7A1.5 1.5 0 0 0 5.5 13H7v1.5a1 1 0 1 0 2 0V13h.5a3 3 0 1 0 0-6H6V5h4.75a1 1 0 1 0 0-2H9V1.5ZM6 11V9h3.5a1 1 0 1 1 0 2H6Z" })));
});
